// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1a1ceaed","239":"d79e7d75","453":"b04a9fa6","667":"4c44d548"}[chunkId] + ".chunk.js";
};